var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"flat":"","icon":""},on:{"click":_vm.handleDownloadResult}},on),[_c('v-icon',[_vm._v("mdi-download-outline")])],1)]}}])},[_c('span',[_vm._v("Download result")])])
}
var staticRenderFns = []

export { render, staticRenderFns }